

import React from 'react'
import { useFiles } from '../useFiles';
import GenericPromises from '../../api/GenericPromises';
import useSnackBar from '../../components/Commons/SnackBar/useSnackBar';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

export const usePdf = () => {

    const { DeleteFileAndMongoFile, GetFileIfExists } = useFiles();

    const { GenericPost } = GenericPromises();

    const [t] = useTranslation("global");

    const DeletePdf = async (fileId: number) => {

        try {
            const file = await GetFileIfExists(fileId)
            await DeleteFileAndMongoFile(fileId, file.object_id).then((response) => {
                toast.success(`${t("generic.reports.PDF-deleted")}`);
                return response;
            })
        } catch (error) {
            toast.error(`${t("generic.reports.PDF-delete-error")}`);
        }
    }


    const SavePdf = async (
        entity: string,
        recordId: number,
        fileName: string | undefined,
        pdfDoc: any,
    ) => {
        try {
            const startIndex = pdfDoc.indexOf(",") + 1;
            const pdfInBase64 = pdfDoc.substring(startIndex);

            const filePayload = {
                entity,
                recordId,
                fileName,
                typeOfFile: "application/pdf",
                schema_name: localStorage.getItem("schemaName"),
                Content: pdfInBase64
            };

            const response = await GenericPost(`/files`, filePayload);
            toast.success(`${t("generic.reports.PDF-saved")}`);
            return response.file_id;
        } catch (error) {
            toast.error(`${t("generic.reports.PDF-save-error")}`);
        }
    };

    const DownloadPdf = async (fileId: number, fileName: string) => {
        try {
            const pdfFile = await GetFileIfExists(fileId);
            const pdfName = `${fileName}.pdf`;
            if (pdfFile?.dataURL) {
                const downloadLink = document.createElement('a');
                downloadLink.href = pdfFile.dataURL;
                downloadLink.download = pdfName;
                downloadLink.click();
                URL.revokeObjectURL(pdfFile.dataURL);
            }
            toast.success(`${t("generic.reports.PDF-downloaded")}`);
        } catch (error) {
            toast.error(`${t("generic.reports.PDF-download-error")}`);
        }
    }

    return {
        DeletePdf,
        SavePdf,
        DownloadPdf,
    }
}
